import { createAsyncThunk } from "@reduxjs/toolkit";
import userApi from "../../Common/Api/UserApi"

export const fetchAds = createAsyncThunk("admin/fetchAds", async ({ }, { rejectWithValue }) => {


    try {
        const { data } = await userApi.get('/admin/ads');
        return data;

    } catch (error) {
        rejectWithValue(error);
    }

})
